import React, { useEffect, useState } from "react";
import axios from "axios";
import {
    useRouteMatch,
} from "react-router-dom";

import PasswordStrengthBar from 'react-password-strength-bar';


import logo from "../../images/logo-01.svg";
import { urls } from "../../config";
import CenterColumn from "../../components/CenterColumn";
import { Input, Text, Button, Loader } from "../../components/ui";
import Container from "../../components/Container";
import RequestPassword from "../RequestPassword";
// import moodleLogo from "../../images/logo.svg";


type Params = {
    id: string;
};

const Page = ({ rootPath }: { rootPath: string }) => {
    const match = useRouteMatch<Params>();
    const id = match.params.id;

    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [passwordScore, setPasswordScore] = useState(0)
    const [failed, setFailed] = useState(false);
    const [finished, setFinished] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [loading, setLoading] = useState(true);
    const [url, setUrl] = useState('');

    useEffect(() => {
        axios.get(`${urls.remoteURL}users/check-forgot/${id}`)
            .then(({ data }) => {
                setUrl(data?.admin ? '/training-manager' : '')
                setLoading(false);
            })
            .catch(() => {
                setFailed(true);
            })
    }, [id])


    const updatePassword = (ev) => {
        ev.preventDefault();

        if (password === "" || passwordScore <= 1 || password !== confirmPassword) {
            return;
        }
        setDisabled(true);
        axios.put(`${urls.remoteURL}users/update-password/${id}`, { password })
            .then((x) => {
                setFinished(true);
            })
            .catch((err) => {

            })
            .finally(() => {
                setDisabled(false);
            });
    };

    if (failed) {
        return (
            // <Error404 parent="forgotten-password" />
            <RequestPassword />
        )
    }

    return (
        <Container classes={['content-center', 'items-center']}>
            <CenterColumn wrapClasses={['bg-gray-100', 'py-4', 'lg:py-12']}>
                <div className="flex flex-col md:flex-row ">
                    <div className="flex-1 text-center">
                        <img src={logo} className="px-8" alt="Nail Knowledge" />
                    </div>
                    <div className="w-5/6 md:w-auto block md:flex-1 self-center">
                        {loading ? <Loader /> :
                            !finished ?
                                <form onSubmit={updatePassword} className={`w-full p-4`}>
                                    <Text className={`text-3xl`}>Set your Password?</Text>
                                    <Text className={`text-sm mb-2 font-extralight`}>Hint: The password should be at least twelve characters long. To make it stronger, use upper and lower case letters, numbers, and symbols like ! " ? $ % ^ & ).</Text>

                                    <div className="grid grid-cols-2 gap-2">

                                        <div>

                                            <Input
                                                type="password"
                                                name="password"
                                                autoComplete="new-password"
                                                // mb={3}
                                                disabled={disabled}
                                                placeholder="Strong Password"
                                                onChange={(ev) => setPassword(ev.target.value)}
                                            />
                                            <PasswordStrengthBar
                                                password={password}
                                                minLength={5}
                                                onChangeScore={(score, feedback) => {
                                                    setPasswordScore(score); // console.log(score, feedback);
                                                }} />
                                        </div>
                                        <div>

                                            <Input
                                                type="password"
                                                name="x"
                                                // mb={3}
                                                error={confirmPassword.length > 0 && password != confirmPassword && 'Password does not match?'}
                                                autoComplete="new-password"
                                                disabled={disabled}
                                                placeholder="Confirm Password"
                                                onChange={(ev) => setConfirmPassword(ev.target.value)}
                                            />
                                        </div>

                                    </div>
                                    <Button type="submit" classes={['mt-4 self-end w-full  rounded']} disabled={disabled} bgColor="bg-nailBlue-600" bgHoverColor="bg-nailBlue-700">Submit Password</Button>
                                </form>
                                :
                                <>
                                    <Text className={`text-3xl mb-2 text-center `}>You have successfully changed your password, please try click here to login.</Text>
                                    <Button href={`${urls.rootURL}${url}`} classes={['mt-4 self-end text-center block w-full rounded']} disabled={disabled} bgColor="bg-nailBlue-600" bgHoverColor="bg-nailBlue-700">Login</Button>
                                </>
                        }
                    </div>

                </div>
            </CenterColumn>
        </Container>
    );
};

export default Page;